var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__a",
    d: "M0 0L12 0 12 10.8 0 10.8z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(6 6)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.795 4.348l-4.8-4.2c-.177-.154-.43-.191-.642-.095C6.138.151 6 .364 6 .6v1.8H4.8C2.153 2.4 0 4.553 0 7.2v3c0 .332.269.6.6.6.332 0 .6-.268.6-.6 0-1.653 1.346-3 3-3H6V9c0 .236.138.45.353.547.212.097.464.06.642-.095l4.8-4.2c.13-.114.205-.278.205-.452 0-.173-.074-.337-.205-.45",
    mask: "url(#prefix__b)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShare);
export default __webpack_public_path__ + "static/media/icon-share.be6da24c00247ddc1717c6df57042b0d.svg";
export { ForwardRef as ReactComponent };